module.exports = __webpack_public_path__ + "nc_static/media/file-xlsx.ed8f2411.svg";